module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_5-c9e0d2abc53975895fd819203ef5c380.jpg";